import {Container, IInit} from "../../../common/container/Container";
import {Observable, of} from "rxjs";
import {DirectTesting, DirectTestingDTO, toModel} from "../models/DirectTesting";
import {HTTP_CLIENT_KEY, IHTTPClient} from "../../../common/api/HTTPClient";
import {IStatusService} from "../../../common/status/StatusService";
import {STATUS_SERVICE_KEY} from "../../../container/app";
import {DirectTestingContainerConfig} from "../container";
import {catchError, map} from "rxjs/operators";
import {emptyList, ItemList} from "../../../common/models/ItemList";


export interface DirectTestingApi extends IInit {
    add(e: DirectTestingDTO): Observable<DirectTesting | undefined>
    getByID(id: string): Observable<ItemList<DirectTesting>>
    getByMutationID(id: string): Observable<ItemList<DirectTesting>>
    getByIndividualID(id: string): Observable<ItemList<DirectTesting>>
    update(e: DirectTestingDTO): Observable<DirectTesting | undefined>
}

export class DirectTestingApi implements DirectTestingApi {
    private _container!: Container
    private _httpClient!: IHTTPClient
    private _url!: string
    private _statusService!: IStatusService

    init(c: Container) {
        this._container = c
        this._httpClient = this._container.get<IHTTPClient>(HTTP_CLIENT_KEY)
        this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
        this._url = (this._container.config as DirectTestingContainerConfig).moduleFullUrlDirectTesting
    }

    add(e: DirectTestingDTO): Observable<DirectTesting | undefined> {
        return this._httpClient.post<DirectTesting>({url: this._url, body: e}).pipe(
            catchError((err) => {
                this._statusService.sendStatus({variant: 'error', error: err})
                return of(undefined)
            })
        )
    }

    getByID(id: string): Observable<ItemList<DirectTesting>> {
        return this._httpClient.get<ItemList<DirectTesting>>({url: `${this._url}/${id}`}).pipe(
            map<ItemList<DirectTestingDTO>, ItemList<DirectTesting>>((dto) => {
                const itemList = emptyList<DirectTesting>()
                itemList.count = dto.count
                itemList.items = dto.items.map((d) => toModel(d))
                return itemList
            }),
            catchError((err) => {
                this._statusService.sendStatus({ variant: 'error', error: err })
                return of(emptyList<DirectTesting>())
            })
        )
    }

    getByMutationID(id: string): Observable<ItemList<DirectTesting>> {
        return this._httpClient.get<ItemList<DirectTesting>>({url: `${this._url}/byVariant/${id}`}).pipe(
            map<ItemList<DirectTestingDTO>, ItemList<DirectTesting>>((dto) => {
                const itemList = emptyList<DirectTesting>()
                itemList.count = dto.count
                itemList.items = dto.items.map((d) => toModel(d))
                return itemList
            }),
            catchError((err) => {
                this._statusService.sendStatus({ variant: 'error', error: err })
                return of(emptyList<DirectTesting>())
            })
        )
    }

    getByIndividualID(id: string): Observable<ItemList<DirectTesting>> {
        return this._httpClient.get<ItemList<DirectTesting>>({url: `${this._url}/byIndividual/${id}`}).pipe(
            map<ItemList<DirectTestingDTO>, ItemList<DirectTesting>>((dto) => {
                const itemList = emptyList<DirectTesting>()
                itemList.count = dto.count
                itemList.items = dto.items.map((d) => toModel(d))
                return itemList
            }),
            catchError((err) => {
                this._statusService.sendStatus({ variant: 'error', error: err })
                return of(emptyList<DirectTesting>())
            })
        )
    }

    update(e: DirectTestingDTO): Observable<DirectTesting | undefined> {
        return this._httpClient.put<any>({url: this._url, body: e}).pipe(
            catchError((err) => {
                this._statusService.sendStatus({variant: 'error', error: err})
                return of(undefined)
            })
        )
    }


}
